import {useQuery} from '@apollo/client';
import {AmlKycOptions, AmlKycOptionsVariables} from '../../schema-types/AmlKycOptions';
import {ContactAmlKyc, ContactAmlKycVariables} from '../../schema-types/ContactAmlKyc';
import validateUUID from '../../utils/validateUUID';
import {GET_AML_KYC_OPTIONS, GET_CONTACT_AML_KYC} from './amlKycQueries';

// Only the primary and secondary contacts appear in the AML/KYC table.
export const useAmlKyc = (accountId: string | undefined, holderIds: string[]) => {
  const variables = {accountId: validateUUID(accountId)!};
  const optionsQuery = useQuery<AmlKycOptions, AmlKycOptionsVariables>(
    GET_AML_KYC_OPTIONS,
    {
      variables,
      skip: !accountId,
    }
  );
  const options = optionsQuery.data?.amlKycOptions ?? null;
  const contactsQuery = useQuery<ContactAmlKyc, ContactAmlKycVariables>(
    GET_CONTACT_AML_KYC,
    {
      variables,
      skip: !accountId || !options?.isEnabled,
    }
  );
  if (optionsQuery.error) {
    console.error('amlKycOptions query failed', optionsQuery.error);
  }
  const contacts = holderIds.flatMap((id) => {
    const contact = contactsQuery.data?.contacts?.find(
      (candidate) => candidate.id === id
    );
    return contact ? [contact] : [];
  });
  return {loading: optionsQuery.loading || contactsQuery.loading, options, contacts};
};
